function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M53.213 21.687a1 1 0 01-.707-.293l-9.9-9.9a1 1 0 010-1.414l6.365-6.364a4.005 4.005 0 015.656 0l5.657 5.657a4.004 4.004 0 010 5.656l-6.364 6.365a1 1 0 01-.707.293zm-8.486-10.9l8.486 8.485 5.657-5.657a2.003 2.003 0 000-2.828L53.213 5.13a2.003 2.003 0 00-2.828 0zM12.201 61.454a3.987 3.987 0 01-2.828-1.17l-5.657-5.656a4.005 4.005 0 010-5.657l6.364-6.364a1.03 1.03 0 011.414 0l9.9 9.9a1 1 0 010 1.414l-6.364 6.363a3.986 3.986 0 01-2.829 1.17zm-1.414-16.726L5.13 50.385a2.003 2.003 0 000 2.829l5.657 5.656a2.003 2.003 0 002.828 0l5.657-5.657z",
  fill: "#373737"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  fill: "#4d4d4d",
  r: 29
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  fill: "#373737",
  r: 27
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M48.971 52.506L35.536 39.071l3.535-3.535 16.264 16.263z",
  fill: "#64964b"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M45.435 56.042L29.929 40.536 33.464 37l18.335 18.335zM52.506 48.971L39.071 35.536 42.607 32 58.87 48.264z",
  fill: "#8cd25f"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  fill: "#fce5bb",
  height: 12,
  rx: 2,
  transform: "rotate(-90 29 15)",
  width: 12,
  x: 23,
  y: 9
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M23 19v-6.485h8.485V21H25a2 2 0 01-2-2z",
  fill: "#fef4e3"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M42.724 29.363a27.07 27.07 0 01-5.447 0 5.699 5.699 0 01-4.93-4.187 19.248 19.248 0 010-10.352 5.698 5.698 0 014.93-4.186 27.056 27.056 0 015.447 0 5.699 5.699 0 014.93 4.186 19.249 19.249 0 010 10.352 5.699 5.699 0 01-4.93 4.187z",
  fill: "#cf8c58"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M48.5 20.5h-2.799a7.624 7.624 0 01-5.982-2.875 5.63 5.63 0 00-4.42-2.125H32.5v-2h2.799a7.624 7.624 0 015.982 2.875 5.63 5.63 0 004.42 2.125H48.5zM47.5 26.5h-2.799a7.624 7.624 0 01-5.982-2.875 5.63 5.63 0 00-4.42-2.125H31.5v-2h2.799a7.624 7.624 0 015.982 2.875 5.63 5.63 0 004.42 2.125H47.5z",
  fill: "#d9a379"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M40 30.5a28.111 28.111 0 01-2.824-.142 6.726 6.726 0 01-5.796-4.923 20.236 20.236 0 010-10.869 6.728 6.728 0 015.796-4.923 28.121 28.121 0 015.647 0 6.726 6.726 0 015.797 4.923 20.232 20.232 0 010 10.868 6.723 6.723 0 01-5.796 4.924 28.078 28.078 0 01-2.823.142zm0-18.999a26.122 26.122 0 00-2.623.132 4.717 4.717 0 00-4.065 3.45 18.322 18.322 0 000 9.836 4.716 4.716 0 004.065 3.449 26.149 26.149 0 005.246 0 4.714 4.714 0 004.065-3.45 18.326 18.326 0 000-9.836 4.715 4.715 0 00-4.065-3.45A26.102 26.102 0 0040 11.502z",
  fill: "#c36f2e"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  fill: "#fce5bb",
  height: 12,
  rx: 2,
  transform: "rotate(-45 19.998 20.005)",
  width: 12,
  x: 14,
  y: 14
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M12.926 18.586l4.585-4.585 6 6-6 5.998-4.585-4.585a2 2 0 010-2.828z",
  fill: "#fef4e3"
});

var _ref14 = /*#__PURE__*/React.createElement("rect", {
  fill: "#fa5046",
  height: 10,
  rx: 2,
  transform: "rotate(180 25 46)",
  width: 20,
  x: 15,
  y: 41
});

var _ref15 = /*#__PURE__*/React.createElement("g", {
  fill: "#ff695f"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.533 41.542a8.246 8.246 0 010 8.917l-.35.541h2.327a10.22 10.22 0 000-10h-2.326zM17.533 41.542a8.246 8.246 0 010 8.917l-.35.541h2.327a10.22 10.22 0 000-10h-2.326zM29.533 41.542a8.246 8.246 0 010 8.917l-.35.541h2.327a10.22 10.22 0 000-10h-2.326z"
}));

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  fill: "#ff8f82",
  height: 10,
  rx: 2,
  transform: "rotate(180 21 37.5)",
  width: 20,
  x: 11,
  y: 32.5
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M19.533 33.042a8.246 8.246 0 010 8.917l-.35.541h2.327a10.22 10.22 0 000-10h-2.326zM13.533 33.042a8.246 8.246 0 010 8.917l-.35.541h2.327a10.22 10.22 0 000-10h-2.326zM25.533 33.042a8.246 8.246 0 010 8.917l-.35.541h2.327a10.22 10.22 0 000-10h-2.326z",
  fill: "#ff695f"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  fill: "#fa5046",
  height: 10,
  rx: 2,
  transform: "rotate(180 19 29)",
  width: 20,
  x: 9,
  y: 24
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M17.533 24.542a8.246 8.246 0 010 8.917l-.35.541h2.327a10.22 10.22 0 000-10h-2.326zM11.533 24.542a8.246 8.246 0 010 8.917l-.35.541h2.327a10.22 10.22 0 000-10h-2.326zM23.533 24.542a8.246 8.246 0 010 8.917l-.35.541h2.327a10.22 10.22 0 000-10h-2.326z",
  fill: "#ff695f"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M40.379 28.483A8.96 8.96 0 0037.067 22a8.994 8.994 0 00-14.64 7.617 4.563 4.563 0 01-.992 3.302 5.985 5.985 0 006.833 9.421 4.841 4.841 0 014.569.46 7.165 7.165 0 004.784 1.148 7.197 7.197 0 004.276-12.237 4.98 4.98 0 01-1.518-3.23z",
  fill: "#f5fcfc"
});

var _ref21 = /*#__PURE__*/React.createElement("circle", {
  cx: 32,
  cy: 32,
  fill: "#ffcb1e",
  r: 6
});

var _ref22 = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 31,
  fill: "#ffe078",
  r: 2
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M50.724 41.363a27.07 27.07 0 01-5.447 0 5.699 5.699 0 01-4.93-4.186 19.248 19.248 0 010-10.353 5.698 5.698 0 014.93-4.186 27.056 27.056 0 015.447 0 5.699 5.699 0 014.93 4.186 19.249 19.249 0 010 10.353 5.699 5.699 0 01-4.93 4.186z",
  fill: "#cf8c58"
});

var _ref24 = /*#__PURE__*/React.createElement("path", {
  d: "M56.5 32.5h-2.799a7.624 7.624 0 01-5.982-2.875 5.63 5.63 0 00-4.42-2.125H40.5v-2h2.799a7.624 7.624 0 015.982 2.875 5.63 5.63 0 004.42 2.125H56.5zM55.5 38.5h-2.799a7.624 7.624 0 01-5.982-2.875 5.63 5.63 0 00-4.42-2.125H39.5v-2h2.799a7.624 7.624 0 015.982 2.875 5.63 5.63 0 004.42 2.125H55.5z",
  fill: "#d9a379"
});

var _ref25 = /*#__PURE__*/React.createElement("path", {
  d: "M48 42.5a28.111 28.111 0 01-2.824-.142 6.726 6.726 0 01-5.796-4.923 20.236 20.236 0 010-10.869 6.728 6.728 0 015.796-4.923 28.121 28.121 0 015.647 0 6.726 6.726 0 015.797 4.923 20.232 20.232 0 010 10.868 6.723 6.723 0 01-5.796 4.924 28.078 28.078 0 01-2.823.142zm0-18.999a26.122 26.122 0 00-2.623.132 4.717 4.717 0 00-4.065 3.45 18.322 18.322 0 000 9.836 4.716 4.716 0 004.065 3.449 26.149 26.149 0 005.246 0 4.714 4.714 0 004.065-3.45 18.326 18.326 0 000-9.836 4.715 4.715 0 00-4.065-3.45A26.102 26.102 0 0048 23.502z",
  fill: "#c36f2e"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M21.637 51.338a1.995 1.995 0 00.723 3.293 6.503 6.503 0 008.271-8.271 1.995 1.995 0 00-3.293-.723l-1.083 1.083-1.414-1.414a1 1 0 00-1.414 0l-2.121 2.12a1 1 0 000 1.415l1.414 1.414z",
  fill: "#fef4e3"
});

var _ref27 = /*#__PURE__*/React.createElement("circle", {
  cx: 35,
  cy: 50,
  fill: "#764c2c",
  r: 7
});

var _ref28 = /*#__PURE__*/React.createElement("path", {
  d: "M36.191 51.191A7.802 7.802 0 0039.454 50a7.803 7.803 0 00-3.263-1.191A7.802 7.802 0 0035 45.546a7.802 7.802 0 00-1.191 3.263A7.803 7.803 0 0030.546 50a7.802 7.802 0 003.263 1.191A7.803 7.803 0 0035 54.455a7.803 7.803 0 001.191-3.264z",
  fill: "#ffe078"
});

function SvgCookingPanFood(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 6 copy",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCookingPanFood);
export default __webpack_public_path__ + "static/media/cooking-pan-food.b9895049.svg";
export { ForwardRef as ReactComponent };